import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-app-download',
  templateUrl: './app-download.component.html',
  styleUrls: ['./app-download.component.scss']
})
export class AppDownloadComponent implements OnInit {

  public devicetype:any = '';
  constructor(private router: Router) { 
    this.devicetype = this.getMobileOperatingSystem();
  }

  ngOnInit(): void {
    if(this.devicetype != ''){
      this.redirectToPlayStore();
    }
  }

  public getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "IOs";
    }
    return "unknown";
  }
  public redirectToPlayStore(){
    if(this.devicetype == 'Android'){
      window.location.href = "https://play.google.com/store/apps/details?id=com.starbucks.in"; 
    }else if(this.devicetype == 'IOs'){
      window.location.href = "https://apps.apple.com/in/app/starbucks-india/id1210203958"; 
    }else if(this.devicetype == 'unknown'){
      window.location.replace('https://www.starbucks.in/dashboard')
    }
  }
}
